import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import ConfirmDialog from "@/components/common/ConfirmDialog";
import { useCarbonSurveysStore } from "../hooks";

const DeleteCarbonSurveyDialog = observer(({ target, openDialog, onClose }) => {
  const { t } = useTran();
  const { deleteLoading, handleDeleteCarbonInventory } =
    useCarbonSurveysStore();

  const handleConfirm = async () => {
    if (!target?.id) return { success: false };
    const result = await handleDeleteCarbonInventory(target.id);
    if (result) {
      onClose?.();
    }
    return result;
  };

  return (
    <ConfirmDialog
      open={openDialog}
      onOpenChange={(openState) => {
        if (!openState) {
          onClose?.();
        }
      }}
      title={t("Delete carbon survey")}
      description={t("This will mark your carbon survey as deleted.")}
      confirmLabel={t("Delete")}
      cancelLabel={t("Cancel")}
      onConfirm={handleConfirm}
      loading={deleteLoading}
      tone="danger"
    />
  );
});

export default DeleteCarbonSurveyDialog;
